import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import AccountSettingDetailsComponent from "./views/AccountSettingDetails";

const AccountSettingDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQs(location.search.substr(1));
  return (
    <AccountSettingDetailsComponent
      id={decodeURIComponent(id)}
      params={params}
    />
  );
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({ defaultMessage: "Account Settings" })}
      />
      <Routes>
        <Route path={":id"} element={<AccountSettingDetails />} />
      </Routes>
    </>
  );
};

export default Component;
